import {defineStore} from 'pinia';
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";
import {setLocalStorage, getLocalStorage} from "@js/helpers.ts"
import {useThemeStore} from "@js/store/ThemeStore.js";
import {useCartStore} from "@js/store/CartStore.js";

export const useCallbackFormsStore = defineStore('callbackFormsStore', {
    state: () => ({
        forms: {
            home_top_form: {
                data: {
                    phone: null,
                    full_name: null,
                    comment: null,
                },
                errors: [],
                sending: false,
            },
            big_form: {
                data: {
                    phone: null,
                    full_name: null,
                    comment: null,
                },
                errors: [],
                sending: false,
            },
            contacts_top_form: {
                data: {
                    phone: null,
                    full_name: null,
                    comment: null,
                },
                errors: [],
                sending: false,
            },
            dark_form: {
                data: {
                    phone: null,
                    full_name: null,
                },
                errors: [],
                sending: false,
            },
            dark_rounded_form: {
                data: {
                    phone: null,
                    full_name: null,
                },
                errors: [],
                sending: false,
            },
            services_top_form: {
                data: {
                    phone: null,
                    full_name: null,
                },
                errors: [],
                sending: false,
            },
            cart_form: {
                data: {
                    phone: null,
                    full_name: null,
                    cart: null,
                    bitrix_title: 'Оформление заказа с сайта Дорожные-Плиты',
                },
                errors: [],
                sending: false,
            }
        },
        popup_callback: {
            data: {
                phone: null,
                full_name: null,
            },
            errors: [],
            sending: false,
            animation_in_progress: false,
        },
        isPopupCallbackVisible: false,
    }),
    actions: {
        send(form) {
            const popupControlStore = usePopupsControlStore()
            form.errors = []

            if (this.isSendingCookieSet()) {
                popupControlStore.showFormAlreadySendPopup()
            } else {
                form.sending = true

                axios.post(route("sendForm"), form.data)
                    .then((res) => {
                        this.resetFormData(form)

                        setLocalStorage('is_already_sent', 'true', 60);
                        popupControlStore.showFormSuccessPopup()
                    })
                    .catch((error) => {
                        form.sending = false

                        if (error.response !== undefined && error.response.status === 422) {
                            form.errors = error.response.data.errors
                        } else {
                            popupControlStore.showErrorPopup()
                        }
                    })
            }
        },
        sendPopupForm() {
            const popupControlStore = usePopupsControlStore()
            this.popup_callback.errors = []

            if (this.isSendingCookieSet()) {
                this.closeCallbackPopup()
                popupControlStore.showFormAlreadySendPopup()
            } else {
                this.popup_callback.sending = true

                axios.post(route("sendForm"), this.popup_callback.data)
                    .then((res) => {
                        this.popup_callback.data.full_name = null
                        this.popup_callback.data.phone = null

                        setLocalStorage('is_already_sent', 'true', 60);

                        this.closeCallbackPopup()
                        popupControlStore.showFormSuccessPopup()
                    })
                    .catch((error) => {
                        this.popup_callback.sending = false

                        if (error.response !== undefined && error.response.status === 422) {
                            this.popup_callback.errors = error.response.data.errors
                        } else {
                            this.closeCallbackPopup()
                            popupControlStore.showErrorPopup()
                        }
                    })
            }
        },
        sendCartForm() {
            const popupControlStore = usePopupsControlStore()
            const cartStore = useCartStore()

            const form = this.forms.cart_form
            form.data.cart = cartStore.cart

            if (cartStore.cart.length > 0) {
                form.errors = []
                form.sending = true

                axios.post(route("sendForm"), form.data)
                    .then((res) => {
                        this.resetFormData(form)
                        cartStore.clearCart()
                        popupControlStore.showCartSuccessPopup()
                    })
                    .catch((error) => {
                        form.sending = false

                        if (error.response !== undefined && error.response.status === 422) {
                            form.errors = error.response.data.errors
                        } else {
                            popupControlStore.showErrorPopup()
                        }
                    })
            }
        },
        resetFormData(form) {
            form.data.phone = null;
            form.data.full_name = null;
            form.data.comment = null;
            form.sending = false
        },
        isSendingCookieSet() {
            return getLocalStorage("is_already_sent") === 'true'
        },
        showCallbackPopup() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(true)
            this.popup_callback.animation_in_progress = false
            this.isPopupCallbackVisible = true

            let vm = this
            setTimeout(function () {
                vm.popup_callback.animation_in_progress = true
            }, 50)
        },
        closeCallbackPopup() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(false)
            this.popup_callback.animation_in_progress = false

            let vm = this
            setTimeout(function () {
                vm.isPopupCallbackVisible = false
                vm.popup_callback.animation_in_progress = true
            }, 500)
        },
    }
});
